import debounce        from 'lodash.debounce';

/**
 * @module
 * card corousel - flickity controller
 */

const selector = '[data-js-card-carousel-section]';
const cardCarousel = function(el, app) {

    let   status = false;
    const $section = $(el);
    const $carousel = $section.find('.Ge-CardGrid-Container');
    const $parent = $carousel.parent();
    const $buttonNext = $carousel.siblings('[data-js-card-carousel-next]').first();
    const $buttonPrev = $carousel.siblings('[data-js-card-carousel-prev]').first();
    let   flktyData = null;
    const viewportMin = 768;
    let   viewportWidth = null;
    let   viewportWidthPrev = null;
    let   numberOfCards = 3;
    let   hasLargeCards = false;

    const init = function() {

        if (typeof $carousel.flickity === 'undefined') {
            return;
        }
        if($parent.hasClass('Ge-CardGrid--columns-4')) numberOfCards = 4;
        if($parent.hasClass('Ge-CardGrid--columns-2')) {numberOfCards = 2; hasLargeCards = true; };

        let cardIconGrid = $section.find('.Ge-CardIcon');
        let carouselItems = $carousel.children(['.Ge-Card', '.Ge-CardIcon']);
        
        if (carouselItems.length <= numberOfCards) {
            hideButtons();
            console.log('Hide');
        }

        runFlickity();
        viewportWidth = window.innerWidth || document.documentElement.clientWidth || $(window).width();

        registerEvents();
        if(hasLargeCards || cardIconGrid.length > 0 ) {
            if (viewportWidth >= viewportMin) {
                runFlickity();
            } else {
                killFlickity();
            }
            onResize();
        }
    };

    const runFlickity = function() {

        // set-up the CSS and remove any fallbacks
        $section.addClass('Ge-Carousel-Section--ready');
        $parent.removeClass('Ge-Carousel--fallback');

        // start flickity up
        $carousel.flickity({
            cellAlign: 'left',
            contain: true,
            groupCells: true,
            prevNextButtons: false,
            adaptiveHeight: hasLargeCards,
        });

        flktyData = $carousel.data('flickity');

        setButtonState();
        status = true;

    };
    const hideButtons = function() {
        $buttonNext.addClass('hide');
        $buttonPrev.addClass('hide');
    }
    
    const showButtons = function() {
        $buttonNext.removeClass('hide');
        $buttonPrev.removeClass('hide');
    }

    const killFlickity = function() {
        
        if ($section.hasClass('Ge-Carousel-Section--ready') && $carousel.flickity()) {
            $carousel.flickity('destroy');
    
            // swap to grid as a fallback
            $section.removeClass('Ge-Carousel-Section--ready');
            $parent.addClass('Ge-Carousel--fallback');
            hideButtons();
            status = false;
        }

    };

    const registerEvents = function() {
        $buttonNext.click(function( ) {
            $carousel.flickity( 'next', false, false );
            setButtonState();
        });
        $buttonPrev.click(function( ) {
            $carousel.flickity( 'previous', false, false );
            setButtonState();
        });
        $carousel.on( 'select.flickity', function() {
            setButtonState();
        });
    };

    const setButtonState = function() {
        if (typeof flktyData === 'undefined') {
            return;
        }
        const current = flktyData.selectedIndex;
        const max = flktyData.slides.length;
        if (current === 0) {
            $buttonPrev.addClass('Ge-Carousel-PrevNext--inactive');
        } else {
            $buttonPrev.removeClass('Ge-Carousel-PrevNext--inactive');
        }
        if (current + 1 >= max) {
            $buttonNext.addClass('Ge-Carousel-PrevNext--inactive');
        } else {
            $buttonNext.removeClass('Ge-Carousel-PrevNext--inactive');
        }
    };

    // don't run flickity on small screens, so monitor resize events and run/kill flickity when necessary
    const onResize = function() {

        let   timer = false;

        const onResizeThrottled = function(ev) {
            // Don't trigger resize on vertical resize (mobile OS' do this all the time just on scroll).
            // Note that we try and do every kind of "soft" measurement before we attempt to recalc styles (which is costly in FPS)
            viewportWidth = ev.target.innerWidth || window.innerWidth || document.documentElement.clientWidth || $(window).width();
            if (viewportWidth != viewportWidthPrev)  {
                if (viewportWidth < viewportMin) {
                    killFlickity();            
                } else {
                    runFlickity();
                    showButtons();
                }
            }
            viewportWidthPrev = viewportWidth;

        };

        // throttle resize events
        $(window).resize(function onResizeUnThrottled (ev) {
            debounce(function() {
                onResizeThrottled(ev);
            }, 600)();
        });

    };

    return {
        init: init()
    };
};

cardCarousel.selector = selector;

export default cardCarousel;
